import { Loader2 } from 'lucide-react';
import SummaryCard from './SummaryCard';

const ConfirmStep = ({ summary, dryRunData, summaryCards, loading, onBack, onStartImport }) => {
  const resolvedSummary = summary || dryRunData?.summary || null;
  const insertCount = resolvedSummary?.insertCount ?? 0;
  const updateCount = resolvedSummary?.duplicateCount ?? 0;
  const invalidCount = resolvedSummary?.invalidCount ?? 0;

  return (
    <div className="rounded-lg border border-gray-200 bg-bg-surface p-6">
      <h2 className="text-lg font-semibold text-text-primary">Confirm import</h2>
      <p className="mt-1 text-sm text-text-secondary">
        This import will follow Bukito&apos;s standard import rules.
      </p>

      <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-5">
        {summaryCards.map((card) => (
          <SummaryCard key={card.label} {...card} />
        ))}
      </div>

      <div className="mt-6 space-y-4 rounded-lg border border-gray-200 p-4">
        <div>
          <h3 className="text-base font-medium text-text-primary">What will happen</h3>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <ul className="space-y-2 text-sm text-text-primary">
            <li>{insertCount} new books will be inserted.</li>
            <li>{updateCount} existing books will be updated.</li>
            <li>{invalidCount} invalid rows may be skipped.</li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-medium text-text-primary">Import rules</div>
          <ul className="mt-3 list-disc space-y-2 pl-5 text-sm text-text-secondary">
            <li>Excel values override existing values when provided.</li>
            <li>Blank Excel cells do not delete existing data.</li>
            <li>New books use Google Books as the base when available.</li>
            <li>Missing fields may be enriched automatically.</li>
            <li>AI tags V2 are generated from the final merged book data.</li>
          </ul>
        </div>
      </div>

      <div className="mt-6 flex gap-3">
        <button
          onClick={onBack}
          className="rounded-lg border border-gray-200 px-4 py-2 text-text-primary hover:bg-gray-50"
        >
          Back to Dry-Run
        </button>
        <button
          onClick={onStartImport}
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-lg bg-primary-500 px-4 py-2 text-white disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          Start Import
        </button>
      </div>
    </div>
  );
};

export default ConfirmStep;
